import { render } from "./AvailableDoctor.vue?vue&type=template&id=0a197436&scoped=true"
import script from "./AvailableDoctor.vue?vue&type=script&lang=js"
export * from "./AvailableDoctor.vue?vue&type=script&lang=js"

import "./AvailableDoctor.vue?vue&type=style&index=0&id=0a197436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a197436"]])

export default __exports__